// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';
import useTranslation from '@/utils/hooks/translation/useTranslation';

const SocialProfilesErrorFetchingData = () => {
    const { t } = useTranslation('commons');

    const { mutateSocialProfiles } = useSocialProfiles();

    return (
        <div className="relative flex flex-col items-center justify-center space-y-2 px-6 text-sm">
            <p>{t('errors:error_occured_fetch_data')}</p>
            <button
                className="text-icoBlue underline"
                type="button"
                onClick={() => mutateSocialProfiles(null)}>
                {t('try_again')}
            </button>
        </div>
    );
};

export default SocialProfilesErrorFetchingData;
